import React, { useContext, useEffect, useState } from 'react'
import { SchemaDBContext } from '../../src/contexts/schemaDB/schemaDBContext';
import { TableDB, FieldDB, ChildForm, SchemaDB } from '../../src/interfaces/schemaDB';
// import { FieldDB, SchemaDB, TableDB } from 'src/interfaces/schemaDB';
import { CrudFilters } from '@refinedev/core/dist/interfaces';
import { useSelect } from '@refinedev/core';
import { useFetch } from './useFetch';
import { nanoid } from 'nanoid';
import { DeleteButton, EditButton, FileField, ShowButton } from '@refinedev/antd';
import { config } from 'config';
import { Tag } from 'antd';
import { ProviderTypes } from 'interfaces/interfaces';


interface UseSchemaDBProps{
    nameTable : string 
}



export const useSchemaDB = ({nameTable} : UseSchemaDBProps) => {


    const {schemaDBState, setSchemaDBState, childrenTables, setCurrentChildrenTables } = useContext(SchemaDBContext)

    const [resource, setResource] = React.useState(nameTable)

    const getTable = (nameTable: string): TableDB[] | null => {
        
        if(nameTable != '' && schemaDBState){
            if(schemaDBState.tables){
                const tables : TableDB[] = schemaDBState.tables.filter( table => table.name == nameTable )

                if(tables.length == 1){ return tables}
                else{
                    return null
                }
            }else{
                return null
            }
        }else{
            return null
        }
    }
    // const table = getTable(resource)
    // const [table, setTable] = useState<TableDB[] | null>(null)
    // console.log(table)


    // const [currentTable, setCurrentTable] = useState<TableDB[] | null>(table)
    // const [isPending, setIsPending] = React.useState(true)
    // const [error, setError] = React.useState<any | null >(null)

    function toSnakeCase(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1_$2') // Agrega "_" entre minúscula y mayúscula
        .replace(/\s+/g, '_') // Reemplaza espacios por "_"
        .toLowerCase(); // Convierte todo a minúsculas
}

    
    // const getListField = (table: TableDB | null, filterList: CrudFilters | undefined): FieldDB[] => {
    const getListField = (table: TableDB | null, filterList: CrudFilters | undefined, editModalShow: ((value: any) => void) | undefined): FieldDB[] => {
        if (table) {

            const resourceName: string = table.name

            const key = table.primaryFieldId
            if (filterList) {
                table.fields.forEach((field) => {
                    //si es una lista hija, no se muestra el ID
                    (field.id == key) ? field.list = 0 : field.list = field.list
                    //las llaves foráneas tampoco se muestran en las listas
                    filterList?.map(filter => {
                        //es un LogicalFilter
                        if ("field" in filter) {
                            filter.field == field.name ? field.list = 0 : field.list = field.list
                        }
                    })
                });
            }

            const listFields: FieldDB[] = []

            table.fields.map((field, idx) => {

                const filedTmp: FieldDB = {
                    id: field.id,
                    type: field.type,
                    name: field.name,
                    label: field.label ? field.label : field.name,
                    required: 1,
                    list: 1,
                    edit: 1,
                    view: 1,
                    insert: 1
                }

                table.fields[idx] = { ...filedTmp, ...field }

            })

            table.fields.filter(field => field.list).forEach(field => {



                if (field.type == 'multipleRecordLinks' || field.type == 'singleSelect') {

                     console.log(toSnakeCase(field.options?.linkedTableName || '') + ("." + field.options?.fieldTxt || ''));

                    listFields.push({

                        id: field.id,
                        type: field.type,
                        name: field.name,

                        label: field.label,
                        required: field.required,
                        list: field.list,
                        edit: field.edit,
                        view: field.view,
                        insert: field.insert,
                        options: field.options,
                        isKey: field.isKey,

                        // .
                        header: field.name,
                        accessorKey: field.name,

                        title: field.label,
                        dataIndex: [toSnakeCase(field.options?.linkedTableName || ''), field.options?.fieldTxt || ''],
                        key: field.name,
                        sorter: true,
                        // filters?: opts[], 
                        filterMultiple: true,
                        filterSearch: true,

                    })

                } else {

                    listFields.push({

                        id: field.id,
                        type: field.type,
                        name: field.name,
                        label: field.label,
                        required: field.required,
                        list: field.list,
                        edit: field.edit,
                        view: field.view,
                        insert: field.insert,
                        options: field.options,
                        isKey: field.isKey,

                        // .
                        header: field.name,
                        accessorKey: field.name,

                        title: field.label,
                        dataIndex: field.name,
                        key: field.name,
                        sorter: true,
                        // filters?: opts[], 
                        filterMultiple: true,
                        filterSearch: true,

                        width: field.type === "check" || field.label == "Id" ? "100px" : undefined,

                        align: field.type === "check" ? "center" : field.label == "Id" ? "right" : undefined,

                        render: (value, record) =>
                            field.type === "check" ? (
                                <Tag color={value ? "green" : "red"}>{value ? "Activo" : "Inactivo"}</Tag> //value ? <CheckSquareOutlined style={{ color: "green" }} /> : <CloseCircleOutlined style={{ color: "red" }} />
                            ) : value


                    })

                }

            })

            listFields.push({

                id: "field.id",
                type: "field.type",
                name: "field.name",
                label: "field.label",
                required: 0,
                list: 0,
                edit: 0,
                view: 0,
                insert: 0,
                // options: ,
                isKey: 0,

                // .
                header: "field.name",
                accessorKey: "field.name",

                title: "Edit",
                dataIndex: "Edit",
                key: "Edit",
                sorter: false,
                // filters?: opts[], 
                filterMultiple: true,
                filterSearch: false,
                width: "100px",
                // align : "center",
                render: (_: any, record: any) => <EditButton
                    recordItemId={record.id}
                    size="small"
                    onClick={editModalShow ? () => editModalShow(record.id) : undefined}
                />,
            })


            listFields.push({

                id: "field.id",
                type: "field.type",
                name: "field.name",
                label: "field.label",
                required: 0,
                list: 0,
                edit: 0,
                view: 0,
                insert: 0,
                // options: ,
                isKey: 0,

                // .
                header: "field.name",
                accessorKey: "field.name",

                title: "Show",
                dataIndex: "Show",
                key: "Show",
                sorter: false,
                // filters?: opts[], 
                filterMultiple: true,
                filterSearch: false,
                width: "100px",
                // align : "center",
                render: (_: any, record: any) => <ShowButton
                    recordItemId={record.id}
                    size="small"
                    resourceNameOrRouteName={resourceName}
                />,
            })

            listFields.push({

                id: "field.id",
                type: "field.type",
                name: "field.name",
                label: "field.label",
                required: 0,
                list: 0,
                edit: 0,
                view: 0,
                insert: 0,
                // options: ,
                isKey: 0,

                // .
                header: "field.name",
                accessorKey: "field.name",

                title: "Delete",
                dataIndex: "Delete",
                key: "Delete",
                sorter: false,
                // filters?: opts[], 
                filterMultiple: true,
                filterSearch: false,
                width: "100px",
                // align : "center",
                render: (_: any, record: any) => <DeleteButton
                    recordItemId={record.id}
                    size="small"
                    resourceNameOrRouteName={resourceName}
                />,
            })

            return listFields
        } else {
            return []
        }

    }

    //los childrenForms son los campos que asocian un form con otro, es decir las FK
    //si vienen, esos campos no debe poder editarse ni verse
    const getEditField = (table: TableDB | null,  childrenForms?: ChildForm[]): FieldDB[] => {

        if(table){
// console.log( table.fields );
            const key = table.primaryFieldId
            table.fields.forEach(
                (field) => {
                    (field.id == key)?field.isKey = 1:field.isKey = 0
                        childrenForms?.forEach( table => {
                            if(table.field == field.name){

                                //esto se queita para airtable pues maneja sus propias llaves

                                if( config.provider == ProviderTypes.airTable ){
                                    field.edit = 0  
                                    field.view = 0 
                                }

                            }
                        })
                    }
                );

            return table.fields.filter( field => field.edit  ||  field.view  )
        }else{
            return []
        }
    }

    const getCreateField = (table: TableDB | null): FieldDB[] => {
        if(table){
            const key = table.primaryFieldId
            // table.fields.forEach((field) => {(field.id == key)?field.insert = false:field.isKey = field.isKey}); //esto se queita para airtable pues maneja sus propias llaves

            table.fields.map( (field,idx) =>{

                const filedTmp : FieldDB = {
                    id : field.id,
                    type : field.type,
                    name : field.name,
                    label: field.label?field.label:field.name,
                    required: 1,
                    list: 1,
                    edit: 0,
                    view: 1,
                    insert: 0
                }

                table.fields[idx] = {...filedTmp, ...field}

            } )
            
            // no insertar campos de tipo file
            table.fields.forEach((field) => {(field.type == 'file' || field.type == 'multipleAttachments' )?field.insert = 0:field.isKey = field.isKey});

            return table.fields.filter( field => field.insert   )
        }else{
            return []
        }
    }

    const getViewField = (table: TableDB | null): FieldDB[] => {
        if(table){
            const key = table.primaryFieldId
            table.fields.forEach((field) => {(field.id == key)?field.view = 1:field.view = field.view});
            return table.fields.filter( field => field.view  )
        }else{
            return []
        }
    }


    //todo esto toco hacerlo porque no se acepta una propiedad dinámica en optionLabel
    function getProperty<T, K extends keyof T>(obj: T, key: K) {
        return obj[key];
    }
        
    
    /*
    // const table = getTable(resource)
    const {data} = useFetch<TableDB>(config.urlResources+"resources/"+nameTable+".json?", table?false:true )//orignal
    useEffect(() => {
        if(data){
            const schemaTmp : TableDB[] = [data]
            addTableSchema(data)
            setCurrentTable(schemaTmp)
        }
        
    }, [data])
    */
   
   // let  data: TableDB[] | null | undefined

    // console.log(schemaDBState)
    // let data = useFetch<TableDB[]>(config.urlResources+"resources/schema.json?", schemaDBState?.tables && schemaDBState?.tables.length > 0 ?false:true )//orignal

//    useEffect(() => {
//        // console.log("Este es UseSchema")
//        // console.log(schemaDBState)
//        // let data = useFetch<TableDB[]>(config.urlResources+"resources/schema.json?", true )//orignal
       
//     }, [])
    
    // useEffect(() => {
    //     console.log("### Este es el schema cargado")
    //     console.log(data)
    //     if(data.data && schemaDBState?.tables.length  == 0){
    //         console.log(nameTable)
    //         setSchemaDBState({tables: data.data})
    //         // console.log( getTable(nameTable) )
    //         // setCurrentTable(getTable(nameTable) )
    //     }else{
    //         console.log("Viene data pero no se carga")
    //         if( nameTable != '' ){
    //             // const t = getTable(nameTable)
    //             // setTable(t)
    //             // setCurrentTable(t)
    //         }
    //     }
    // }, [data])
    


    return{
        schemaDBState
        , getTable
        , getListField
        , getEditField
        , getCreateField
        , getViewField
        , getProperty
        , childrenTables
        , setCurrentChildrenTables
        // , currentTable
    }

}

